import { render } from "./SncrSection.vue?vue&type=template&id=0881f494&scoped=true"
import script from "./SncrSection.vue?vue&type=script&lang=js"
export * from "./SncrSection.vue?vue&type=script&lang=js"

import "./SncrSection.vue?vue&type=style&index=0&id=0881f494&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0881f494"]])

export default __exports__